import { useSelector } from 'react-redux';
import { Image } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { Hostname } from 'constants/hostnames';
import { STATIC_ASSETS_URL } from 'constants/index';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getLocale } from 'state/intl/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
var Platform;

(function (Platform) {
  Platform["Android"] = "android";
  Platform["Ios"] = "ios";
})(Platform || (Platform = {}));

const url = {
  [Platform.Android]: "https://".concat(Hostname.Fr, "/l/app-android-landing"),
  [Platform.Ios]: "https://".concat(Hostname.Fr, "/l/app-ios-landing")
};
const clickTarget = {
  [Platform.Android]: ClickableElement.DownloadAndroidApp,
  [Platform.Ios]: ClickableElement.DownloadIosApp
};

const AppButton = _ref => {
  let {
    platform
  } = _ref;
  const {
    track
  } = useTracking();
  const translate = useTranslate('app_store_buttons');
  const locale = useSelector(getLocale);
  const imageDir = "".concat(STATIC_ASSETS_URL, "/assets/app-badges/").concat(platform);
  const language = locale.split('-')[0];

  function handleClick() {
    track(clickEvent({
      target: clickTarget[platform]
    }));
  }

  return /*#__PURE__*/_jsx("a", {
    href: url[platform],
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(Image, {
      src: "".concat(imageDir, "/").concat(language, ".svg"),
      fallbackSrc: "".concat(imageDir, "/default.svg"),
      alt: translate("a11y.".concat(platform))
    })
  });
};

AppButton.Platform = Platform;
export default AppButton;